import logo from './logo.svg';
import './App.css';

import React, { useState, useEffect, useMemo } from 'react';

const isLocal = ['localhost', '127.0.0.1'].includes(
  //TODO: Not whatever this is
  window.location.hostname.split(".")[window.location.hostname.split(".").length-1] 
);

const API_PREFIX = isLocal ? '' : '/api';

const apiFetch = async (endpoint, options = {}) => {
  const token = localStorage.getItem('token') || "None";
  const headers = {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` }),
    ...options.headers,
  };

  const response = await fetch(`${API_PREFIX}${endpoint}`, { ...options, headers });
  
  if (response.status === 401) {
    localStorage.removeItem('token');
    window.location.reload(); // Force re-login if session expires
  }
  
  return response.json();
};

export const QueryAPI = {
  // Silver Layer: Employee history
  
  
  getSilverRecords: (employeeId = null) => 
    apiFetch(`/data/silver${employeeId ? `?employee_id=${employeeId}` : ''}`),

  // Gold Layer: Audit History
  getAudits: (minConfidence = null) => 
    apiFetch(`/audits${minConfidence ? `?min_confidence=${minConfidence}` : ''}`),

  getEmployees: () => apiFetch('/employees'),
  
  // Bronze Layer: Raw Files
  getAllFiles: (minConfidence = null) => {  
    return apiFetch(`/data/silver`);
  },


  // Agentic Audit Trigger
  runAudit: (payload) => 
    apiFetch('/audit/query', {
      method: 'POST',
      body: JSON.stringify(payload),
    }),
    
  deleteAudit: (auditId) =>
    apiFetch(`/audit/${auditId}`, {
      method: 'DELETE'
    }),
	
	// Ingestion: Uploading to Bronze/Silver
  uploadDocument: (formData) => {
    const token = localStorage.getItem('token');
    return fetch(`/ingest/upload`, {
      method: 'POST',
      headers: { ...(token && { 'Authorization': `Bearer ${token}` }) },
      body: formData,
    }).then(res => res.json());
  }
};

const AuditTraceTable = () => {
  const [audits, setAudits] = useState([]);

  const fetchAudits = () => {
    QueryAPI.getAudits().then(setAudits);
  };

  useEffect(() => {
    fetchAudits();
    window.addEventListener('auditDeleted', fetchAudits);
    window.addEventListener('auditAdded', fetchAudits);
    return () => {
      window.removeEventListener('auditDeleted', fetchAudits);
      window.removeEventListener('auditAdded', fetchAudits);
    };
  }, []);

  const getScoreColor = (score) => {
    if (score >= 0.9) return '#28a745'; // Green for Truth
    if (score >= 0.7) return '#ffc107'; // Yellow for Warning
    return '#dc3545'; // Red for Hallucination
  };

  return (
    <div style={{ marginTop: '2rem' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '1rem' }}>
        <thead>
          <tr style={{ textAlign: 'left', borderBottom: '2px solid #eee' }}>
            <th style={{ padding: '0.75rem' }}>Timestamp</th>
            <th style={{ padding: '0.75rem' }}>Question / Rule</th>
            <th style={{ padding: '0.75rem' }}>Involved Records</th>
            <th style={{ padding: '0.75rem' }}>Confidence</th>
            <th style={{ padding: '0.75rem' }}>Trace Snippet</th>
          </tr>
        </thead>
        <tbody>
          {audits.map((audit) => (
            <tr key={audit.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
              <td style={{ padding: '0.75rem', fontSize: '0.85rem' }}>{audit.timestamp}</td>
              <td style={{ padding: '0.75rem', fontWeight: '500' }}>{audit.query}</td>
              <td style={{ padding: '0.75rem' }}>
                {audit.record_ids.map(id => (
                  <span key={id} style={{ marginRight: '4px', background: '#eee', padding: '2px 6px', borderRadius: '4px', fontSize: '0.75rem' }}>
                    #{id}
                  </span>
                ))}
              </td>
              <td style={{ padding: '0.75rem', fontWeight: 'bold', color: getScoreColor(audit.confidence_score) }}>
                {(audit.confidence_score * 100).toFixed(1)}%
              </td>
              <td style={{ padding: '0.75rem', fontSize: '0.85rem', color: '#555' }}>
                <details>
                  <summary>View Reasoning</summary>
                  <div style={{ marginTop: '0.5rem', background: '#f9f9f9', padding: '0.5rem', borderLeft: '3px solid #0069ff' }}>
                    {audit.trace}
                  </div>
                </details>
                <div style={{ marginTop: '0.5rem' }}>
                  <button 
                    onClick={async () => {
                      if(window.confirm('Delete this audit trace?')) {
                        try {
                          await QueryAPI.deleteAudit(audit.id);
                          fetchAudits();
                        } catch(e) {
                          console.error("Delete failed", e);
                        }
                      }
                    }}
                    style={{ fontSize: '0.75rem', color: '#dc3545', border: 'none', background: 'transparent', cursor: 'pointer', padding: 0 }}
                  >
                    Delete Trace
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const AuditHistoryView = () => {
  const [audits, setAudits] = useState([]);
  const [records, setRecords] = useState([]);

  useEffect(() => {
    // Load all employees initially
    
  }, []);

  return (
	<>
		<div>
		  <h2>Past Audit Traces</h2>
		  < AuditTraceTable />
		</div>
	
		< ChatSidebar />
    </>
  );
};

const FileListView = ({ role }) => {
  const [files, setFiles] = useState([]);

  useEffect(() => {
    fetch(`/files?isAdmin=${role === 'admin'}`).then(res => res?.json()).then(setFiles);
	QueryAPI.getFiles().then((newFiles) =>{
		console.log(newFiles);
	});
  }, [role]);
// {files?.map(file => (
          // <div key={file.id} style={{ padding: '1rem', border: '1px solid #ddd', borderRadius: '4px' }}>
            // <strong>{file.filename}</strong> 
            // {role === 'admin' && <span style={{ color: '#666' }}> — User: {file.user_owner}</span>}
            // <span style={{ float: 'right' }}>Status: <i>{file.status}</i></span>
          // </div>
        // ))}
  return (
    <div>
      <h2>{role === 'admin' ? "Global File Management (All Users)" : "My Uploaded Files"}</h2>
      <div className="file-grid" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        
      </div>
    </div>
  );
};

const UploadView = () => {
	
	
	const styles = {
	  flowBox: { flex: 1, textAlign: 'center', padding: '1rem', border: '1px solid #eee', borderRadius: '8px', background: '#fcfcfc' },
	  label: { fontSize: '0.7rem', fontWeight: 'bold', color: '#888', marginBottom: '0.5rem' },
	  img: { width: '100%', borderRadius: '4px' },
	  uploadZone: { border: '2px dashed #0069ff', padding: '3rem', textAlign: 'center', borderRadius: '12px', background: '#f0f7ff' },
	  button: { background: '#0069ff', color: '#fff', padding: '0.8rem 2rem', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', display: 'inline-block' }
	};
	
  const [uploading, setUploading] = useState(false);
  const [status, setStatus] = useState(null);

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    setUploading(true);
    setStatus('Processing forensic extraction...');

    try {
      const res = await QueryAPI.uploadDocument(formData);
      setStatus(res.status === 'success' ? 'Ingested to Silver Layer!' : `Error: ${res.reason}`);
    } catch (err) {
      setStatus('Upload failed. Check server connection.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ maxWidth: '900px', margin: '0 auto', padding: '2rem' }}>
      <h2 style={{ fontWeight: '700' }}>Ingestion Pipeline</h2>
      

      {/* Functional Upload Section */}
      <div style={styles.uploadZone}>
        <h3>Upload New Evidence</h3>
        <p style={{ color: '#666', marginBottom: '1.5rem' }}>
          Select a paystub to ingest it into the <b>Bronze Layer</b> for processing.
        </p>
        
        <input 
          type="file" 
          id="fileInput" 
          style={{ display: 'none' }} 
          onChange={handleFileUpload} 
          disabled={uploading}
        />
        
        <label htmlFor="fileInput" style={styles.button}>
          {uploading ? 'Processing...' : 'Select Paystub File'}
        </label>

        {status && (
          <div style={{ marginTop: '1.5rem', fontWeight: 'bold', color: '#0069ff' }}>
            {status}
          </div>
        )}
      </div>
	  
	  
	  <h3>This is how the Sample Data was generated for the pipeline, but more formats will be tested soon</h3>
      {/* Visualizer Section */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', marginBottom: '3rem' }}>
        <div style={styles.flowBox}>
          <div style={styles.label}>TEMPLATE</div>
          <img src="/Employee-Pay-Stub-Template.jpg" alt="Template" style={styles.img} />
        </div>
        <div style={{ fontSize: '2rem', color: '#0069ff' }}>→</div>
        <div style={styles.flowBox}>
          <div style={styles.label}>FILLED RECORD</div>
          <img src="/Paystub_August.jpg" alt="Filled" style={styles.img} />
        </div>
      </div>
	  
	  
    </div>
  );
};


const LoginComponent = ({ onLogin, setToken }) => {
  const [credentials, setCredentials] = useState({ username: 'admin', password: '' });
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    try {
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(credentials),
      });

      if (response.ok) {
        const data = await response.json();
        setToken(data.access_token);
      } else {
        setError('Credentials mismatch. Check your superuser password.');
      }
    } catch (err) {
      setError('Connection failed. Is the logic-api running?');
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10vh' }}>
      <form onSubmit={handleSubmit} style={{ width: '300px', padding: '2rem', border: '1px solid #ddd', borderRadius: '8px' }}>
        <h2 style={{ textAlign: 'center' }}>Identity Verification</h2>
        {error && <p style={{ color: 'red', fontSize: '0.8rem' }}>{error}</p>}
        
        <div style={{ marginBottom: '1rem' }}>
          <label>Username</label>
          <input 
            type="text" 
            value={credentials.username}
            onChange={(e) => setCredentials({...credentials, username: e.target.value})}
            style={{ width: '100%', padding: '0.5rem', marginTop: '0.25rem' }}
          />
        </div>

        <div style={{ marginBottom: '1.5rem' }}>
          <label>Password</label>
          <input 
            type="password" 
            placeholder="eliteworkflow"
            value={credentials.password}
            onChange={(e) => setCredentials({...credentials, password: e.target.value})}
            style={{ width: '100%', padding: '0.5rem', marginTop: '0.25rem' }}
          />
        </div>

        <button type="submit" style={{ width: '100%', padding: '0.75rem', backgroundColor: '#0069ff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
          Access Dashboard
        </button>
      </form>
    </div>
  );
};

const AdminPanel = () => {
  const [employees, setEmployees] = useState([]);
  const [allFiles, setAllFiles] = useState([]);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [expandedItems, setExpandedItems] = useState({});

  useEffect(() => {
    QueryAPI.getEmployees().then(setEmployees);
    QueryAPI.getAllFiles().then(setAllFiles);
  }, []);

  // Toggle accordion state
  const toggle = (key) => {
    setExpandedItems(prev => ({ ...prev, [key]: !prev[key] }));
  };

  // Group and Aggregate Data
  const groupedData = useMemo(() => {
    const data = {};
    if(allFiles && allFiles.length>0){
      
      allFiles.forEach(file => {
        const eId = file.employee_id;
        const year = file.pay_period_year;
        const netPay = parseFloat(file.data?.net_pay || 0);

        if (!data[eId]) {
          const empMeta = employees?.find(e => e.employee_id === eId);
          data[eId] = {
            name: file.data?.employee_name || empMeta?.full_name || 'Unknown',
            years: {},
            grandTotal: 0,
            totalYears: 0
          };
        }

        if (!data[eId].years[year]) {
          data[eId].years[year] = { months: [], subtotal: 0, count: 0 };
          data[eId].totalYears += 1;
        }

        data[eId].years[year].months.push(file);
        data[eId].years[year].subtotal += netPay;
        data[eId].years[year].count += 1;
        data[eId].grandTotal += netPay;
      });

    }

    return data;
  }, [allFiles, employees]);

  const displayedEmployeeIds = selectedEmployeeId ? [selectedEmployeeId] : Object.keys(groupedData);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', fontFamily: 'sans-serif' }}>
      {/* 1. Filter Bar */}
      <div style={{ padding: '1rem', borderBottom: '2px solid #eee', background: '#f9f9f9', display: 'flex', alignItems: 'center' }}>
        <input type="text" placeholder="Global search..." style={{ width: '300px', padding: '0.5rem' }} />
        <span style={{ marginLeft: '1rem', color: '#888' }}>
          Registry: {allFiles.length} Records Across {Object.keys(groupedData).length} Entities
        </span>
      </div>

      <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        {/* 2. Main Content: Nested Accordions */}
        <div style={{ flex: 1, padding: '2rem', overflowY: 'auto', background: '#fff' }}>
          <h3>Document Repository</h3>
          
          {displayedEmployeeIds.map(eId => {
            const emp = groupedData[eId];
            const isEmpExpanded = expandedItems[eId];

            return (
              <div key={eId} style={{ marginBottom: '1rem', border: '1px solid #ddd', borderRadius: '8px', overflow: 'hidden' }}>
                {/* Employee Accordion Bar */}
                <div 
                  onClick={() => toggle(eId)}
                  style={{ padding: '1rem', background: '#f0f4f8', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                >
                  <div>
                    <span style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>{emp.name}</span>
                    <span style={{ marginLeft: '10px', fontSize: '0.8rem', color: '#666' }}>ID: {eId}</span>
                  </div>
                  <div style={{ fontSize: '0.9rem' }}>
                    <strong>Total Net: ${emp.grandTotal.toLocaleString()}</strong> | {emp.totalYears} Years History
                  </div>
                </div>

                {isEmpExpanded && (
                  <div style={{ padding: '1rem', background: '#fff' }}>
                    {Object.keys(emp.years).sort((a,b) => b-a).map(year => {
                      const yrData = emp.years[year];
                      const yrKey = `${eId}-${year}`;
                      const isYrExpanded = expandedItems[yrKey];

                      return (
                        <div key={year} style={{ marginBottom: '0.5rem', border: '1px solid #eee', borderRadius: '4px' }}>
                          {/* Year Accordion Bar */}
                          <div 
                            onClick={() => toggle(yrKey)}
                            style={{ padding: '0.5rem 1rem', background: '#f9f9f9', cursor: 'pointer', display: 'flex', justifyContent: 'space-between' }}
                          >
                            <span style={{ fontWeight: '600' }}>{year} Fiscal Year</span>
                            <span style={{ fontSize: '0.85rem' }}>
                              Subtotal: ${yrData.subtotal.toLocaleString()} ({yrData.count} months)
                            </span>
                          </div>

                          {isYrExpanded && (
                            <div style={{ padding: '1rem', display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px' }}>
                              {yrData.months.map(file => (
                                <div key={file.record_id} style={{ padding: '8px', border: '1px solid #eee', borderRadius: '4px', fontSize: '0.85rem' }}>
                                  <div style={{ color: '#0069ff', fontWeight: 'bold' }}>{file.pay_period_month}</div>
                                  <div>${file.data?.net_pay}</div>
                                </div>
                              ))}
                              {/* Total Card */}
                              <div style={{ padding: '8px', background: '#eef', borderRadius: '4px', fontSize: '0.85rem', fontWeight: 'bold' }}>
                                <div>YEAR TOTAL</div>
                                <div>${yrData.subtotal.toLocaleString()}</div>
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* 3. Right Sidebar */}
        <div style={{ width: '250px', borderLeft: '1px solid #eee', padding: '1rem', background: '#fdfdfd' }}>
          <h4>Identity Filter</h4>
          <div 
            onClick={() => setSelectedEmployeeId(null)}
            style={{ padding: '0.5rem', cursor: 'pointer', background: !selectedEmployeeId ? '#eef' : 'transparent', borderRadius: '4px' }}
          >
            Show All Individuals
          </div>
          
          {
          employees.length>0 ?
          employees.map(emp => (
            <div 
              key={emp.employee_id}
              onClick={() => setSelectedEmployeeId(emp.employee_id)}
              style={{ 
                padding: '0.5rem', 
                cursor: 'pointer', 
                borderRadius: '4px',
                marginTop: '4px',
                background: selectedEmployeeId === emp.employee_id ? '#eef' : 'transparent'
              }}
            >
              {emp.full_name}
              <div style={{ fontSize: '0.7rem', color: '#999' }}>{emp.company_name}</div>
            </div>
          )) : <>No Employees found</>
        }
        </div>
      </div>
    </div>
  );
};

const SearchIcon = () => (
  <svg 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2.5" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <circle cx="11" cy="11" r="8"></circle>
    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
  </svg>
);

const ChatSidebar = () => {
  const [isOpen, setIsOpen] = useState(false); // Toggle for floating state
  const [query, setQuery] = useState('');
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleDelete = async (index, auditId) => {
    try {
      if (auditId) {
        await QueryAPI.deleteAudit(auditId);
      }
      setMessages(prev => prev.filter((_, i) => i !== index && i !== index - 1));
      window.dispatchEvent(new Event('auditDeleted'));
    } catch (err) {
      console.error("Failed to delete", err);
    }
  };

  const handleSend = async () => {
    if (!query.trim()) return;
    const userMessage = { role: 'user', text: query };
    setMessages([...messages, userMessage]);
    setLoading(true);
    setQuery('');

    try {
      const res = await QueryAPI.runAudit({
        record_ids: [], 
        query: query,
        admin_rule: "forensic_discovery"
      });
      setMessages(prev => [...prev, { 
        role: 'agent', 
        text: res.trace,
        score: res.confidence_score,
        record_ids: res.record_ids,
        id: res.id
      }]);
      window.dispatchEvent(new Event('auditAdded'));
    } catch (err) {
      setMessages(prev => [...prev, { role: 'error', text: 'Discovery failed.' }]);
    } finally {
      setLoading(false);
    }
  };

  // --- Floating Styles ---
  const containerStyle = {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    width: isOpen ? '400px' : '60px',
    height: isOpen ? '600px' : '60px',
    background: '#fff',
    borderRadius: isOpen ? '12px' : '30px',
    boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
    display: 'flex',
    flexDirection: 'column',
    transition: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
    zIndex: 1000,
    overflow: 'hidden',
    border: '1px solid #ddd'
  };

  return (
    <div style={containerStyle}>
      {/* Header / Toggle Button */}
      <div 
        onClick={() => setIsOpen(!isOpen)}
        style={{ 
          padding: '1rem', 
          background: '#0069ff', 
          color: '#fff', 
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '60px',
          boxSizing: 'border-box'
        }}
      >
        <span style={{ fontWeight: 'bold' }}>{isOpen ? 'Agentic Auditor' : <SearchIcon />}</span>
        {isOpen && <span>▼</span>}
      </div>

      {isOpen && (
        <>
          <div style={{ flex: 1, overflowY: 'auto', padding: '1rem', background: '#f8f9fa' }}>
            {messages.length === 0 && (
              <div style={{ color: '#888', fontSize: '0.9rem', textAlign: 'center', marginTop: '2rem' }}>
                Ask a forensic question to begin discovery...
              </div>
            )}
            {messages.map((m, i) => (
              <div key={i} style={{ marginBottom: '1rem', textAlign: m.role === 'user' ? 'right' : 'left' }}>
                <div style={{ 
                  display: 'inline-block', 
                  padding: '0.8rem', 
                  borderRadius: '12px', 
                  fontSize: '0.9rem',
                  lineHeight: '1.4',
                  background: m.role === 'user' ? '#0069ff' : '#fff',
                  color: m.role === 'user' ? '#fff' : '#333',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                  maxWidth: '85%'
                }}>
                  {m.text}
                  {m.record_ids && m.record_ids.length > 0 && (
                    <div style={{ marginTop: '8px', borderTop: '1px solid #eee', paddingTop: '4px', fontSize: '0.7rem' }}>
                      <b>Evidence:</b> {m.record_ids.join(', ')}
                    </div>
                  )}
                  {m.role === 'agent' && m.id && (
                    <div style={{ marginTop: '8px', borderTop: '1px solid #eee', paddingTop: '4px', textAlign: 'right' }}>
                      <button 
                        onClick={() => handleDelete(i, m.id)}
                        style={{ fontSize: '0.75rem', color: '#dc3545', border: 'none', background: 'transparent', cursor: 'pointer', padding: 0 }}
                        title="Delete this question and trace"
                      >
                        Delete Record
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ))}
            {loading && <div style={{ fontSize: '0.8rem', color: '#888' }}>Searching Silver Layer...</div>}
          </div>

          <div style={{ padding: '1rem', borderTop: '1px solid #eee' }}>
            <textarea 
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="e.g. 'Highest pay for Robert?'"
              style={{ width: '100%', height: '50px', padding: '8px', borderRadius: '4px', border: '1px solid #ddd', resize: 'none' }}
              onKeyDown={(e) => e.key === 'Enter' && !e.shiftKey && (e.preventDefault(), handleSend())}
            />
            <button 
              onClick={handleSend}
              disabled={loading}
              style={{ width: '100%', marginTop: '8px', padding: '10px', background: '#0069ff', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}
            >
              Run Discovery
            </button>
          </div>
        </>
      )}
    </div>
  );
};


const App = () => {
  const [user, setUser] = useState(null); // { name: 'Josh', role: 'admin' }
  const [view, setView] = useState('files'); // 'files', 'upload', 'audits'
  const [token, setToken] = useState(localStorage.getItem("token"));
  //if (!user) return <Login onLogin={() => setUser({ name: 'Josh', role: 'admin' })} />;

  const handleLogin = async (username, password) => {
    const res = await fetch("/api/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password })
    });
    
    if (res.ok) {
      const data = await res.json();
      localStorage.setItem("token", data.access_token);
      setToken(data.access_token);
    } else {
      alert("Unauthorized: Truthiness identity mismatch.");
    }
  };
  
  const getNavLinkStyle = (targetView) => ({
    padding: '0.5rem 0.2rem',
    cursor: 'pointer',
    fontWeight: '700', // Bolder text
    fontSize: '0.9rem',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    color: view === targetView ? '#0069ff' : '#666',
    borderBottom: view === targetView ? '3px solid #0069ff' : '3px solid transparent',
    transition: 'all 0.2s ease-in-out',
    display: 'inline-block'
  });
  // if (!token) return <LoginComponent onLogin={handleLogin} setToken={setToken} />;

  return (
    <div className="app-container">
      <nav style={{ 
        padding: '0 2rem', 
        height: '60px',
        background: '#fff', 
        display: 'flex', 
        alignItems: 'center',
        gap: '2rem', 
        borderBottom: '1px solid #ddd',
        boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
      }}>
        {/* Navigation Items */}
        <span style={getNavLinkStyle('files')} onClick={() => setView('files')}>
          View Files
        </span>
        <span style={getNavLinkStyle('upload')} onClick={() => setView('upload')}>
          Upload
        </span>
        <span style={getNavLinkStyle('audits')} onClick={() => setView('audits')}>
          Audit Traces
        </span>

        {/* User Info & Logout */}
        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
          <span style={{ fontSize: '0.85rem', color: '#555' }}>
            Logged in as: <b style={{ color: '#000' }}>{user?.name || "Super User"}</b> 
            <span style={{ color: '#888', marginLeft: '4px' }}>({user?.role || "Admin"})</span>
          </span>
          <button 
            onClick={() => setUser(null)}
            style={{ 
              background: 'none', 
              border: '1px solid #ddd', 
              padding: '4px 12px', 
              borderRadius: '4px', 
              cursor: 'pointer',
              fontSize: '0.8rem'
            }}
          >
            Logout
          </button>
        </div>
      </nav>

      <main style={{ padding: '2rem' }}>
        {view === 'files' && <AdminPanel role={user?.role || "None"} />}
        {view === 'upload' && <UploadView />}
        {view === 'audits' && <AuditHistoryView />}
      </main>
    </div>
  );
};

export default App;
